<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import type { IColumnDefinition, RowData, ITimeColumn } from '../types';
import { useItpDatetime } from '../../forms/useItpDatetime';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
  autofocus?: boolean;
}>();
const emit = defineEmits(['update:modelValue', 'change']);
const pickerRef = ref<any>(null);

const col = computed(() => props.column as ITimeColumn);

const { lang, displayFormat, modelValueType, popupOpen } = useItpDatetime({
  type: 'time',
});

const currentValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

onMounted(() => {
  if (props.autofocus) {
    pickerRef.value?.$el?.querySelector('input')?.focus();
  }
});
</script>

<template>
  <DatePicker
    ref="pickerRef"
    v-model:value="currentValue"
    v-model:open="popupOpen"
    type="time"
    :format="displayFormat"
    :value-type="modelValueType"
    :lang="lang"
    input-class="form-control form-control-sm"
    :input-attr="{ name: col.name }"
    :placeholder="col.placeholder"
    :clearable="!col.required"
    :disabled="col.editorIsDisabled ? col.editorIsDisabled(row) : false"
    @change="emit('change', $event)"
    @click.stop
  />
</template>
